import { render, staticRenderFns } from "./GoalDetail.vue?vue&type=template&id=2c866822&scoped=true"
import script from "./GoalDetail.vue?vue&type=script&lang=js"
export * from "./GoalDetail.vue?vue&type=script&lang=js"
import style0 from "./GoalDetail.vue?vue&type=style&index=0&id=2c866822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c866822",
  null
  
)

export default component.exports